<template>
    <div class="loginbg" id="login-main-hr">
        <div class="container">
            <div class="row">
                <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
                    <div class="loginform">
                        <div class="loginlogo">
                            <img src="/static/images/login-logo.png" alt="Velocity Vehicle Group">
                        </div>
                        <form @submit.prevent="attemptResetPassword();" id="ResetPasswordCustomerForm" name="form">
                            <h2> Reset Password </h2>
                            <div class="form-group">
                                <label for="username">Password<span class="text-danger">*</span></label>
                                <input v-model="password" type="password" name="password" class="form-control" id="password" placeholder="" @input="checkPasswordStrength" maxlength="64">
                                <small>Password should be 12-64 characters long.</small>
                                <br/>
                                <div v-show="password != ''">
                                    <div class="strength-meter">
                                <div 
                                    class="strength-bar"
                                    :style="{ width: strengthPercentage + '%', backgroundColor: strengthColor }"
                                ></div>
                                </div>
                                <div class="strength-label" :style="{ color: strengthColor }">
                                <small>{{ passwordStrength }}</small>
                                </div>
                                </div>
                                <span class="help is-danger">{{frontendErrors.password}}</span>
                            </div>
                            <div class="form-group">
                                <label for="username">Confirm Password<span class="text-danger">*</span></label>
                                <input v-model="cpassword" type="password" name="cpassword" class="form-control" id="cpassword" placeholder="">
                                <span class="help is-danger">{{frontendErrors.cpassword}}</span>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-offset-0 col-sm-offset-3 col-md-offset-3 col-lg-offset-3">
                                <font class="text-danger"> <label id="errorMsg" class="error text-danger"></label><br> </font>
                            </div>
                            <div>
                                <button :disabled="disableButtons.submitButton" class="btn btn-primary" id="sendEmail">{{buttonNames.submitButton}}</button>
                                <button type="button" :disabled="disableButtons.backButton" class="btn btn-primary" v-on:click.prevent="backBtn()">{{buttonNames.backButton}}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {customer_login} from '../../config';
    import {HTTP} from '../../http-common';
    import EventBus from '.././event-bus';
    import zxcvbn from "zxcvbn"; 
    var self;

    export default {
        name: 'CustomerResetPassword',
        data() {
            return {
                customerToken: '',
                password: '',
                cpassword: '',
                frontendErrors: {
                    password: '',
                    cpassword: '',
                },
                buttonNames : {
                    submitButton : 'Submit',
                    backButton : 'Back',
                },
                disableButtons : {
                    submitButton : false,
                    backButton : false,
                },
                passwordStrength: "Very Weak",
                compromisedPasswords: ["password", "123456", "qwerty", "letmein"],
                strengthPercentage: 0,
                strengthColor: "red",
            }
        },
        created: function () {
        },
        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            $('#main-header').hide();
            $('#sidebar-wrapper').hide();
            $("#wrapper").addClass("login-div-full");
            $(".loginbg").show();
            self.customerToken = this.$route.params.token;
        },
        methods: {
            backBtn: function () {
                self.$router.push('/');
            },
            checkPasswordStrength() {

                const result = zxcvbn(self.password);
                // Map the strength score to labels and colors
                const strengthMap = [
                    { label: "Very Weak", color: "red", percentage: 20 },
                    { label: "Weak", color: "orange", percentage: 40 },
                    { label: "Fair", color: "yellow", percentage: 60 },
                    { label: "Good", color: "blue", percentage: 80 },
                    { label: "Strong", color: "green", percentage: 100 },
                ];
                const { label, color, percentage } = strengthMap[result.score];
                self.passwordStrength = label;
                self.strengthColor = color;
                self.strengthPercentage = percentage;

                if (self.compromisedPasswords.includes(self.password)) {
                    self.passwordStrength = "Compromised";
                }
            },
            checkForm: function () {
                var checked = true;
                self.frontendErrors.password = "";
                self.frontendErrors.cpassword = "";
                if (!self.password) {
                    self.frontendErrors.password = 'Password Required';
                    if (checked) {
                        checked = false;
                    }
                }else{
                    if (self.password.length < 12 || self.password.length > 64) {
                        self.frontendErrors.password = "Password must be between 12 and 64 characters";
                        if (checked) {
                            checked = false;
                        }
                    }
                    if (self.passwordStrength === "Very Weak" || self.passwordStrength === "Weak") {
                        self.frontendErrors.password = "Please choose a stronger password.";
                        if (checked) {
                            checked = false;
                        }
                    }
                    if (self.passwordStrength === "Compromised") {
                        self.frontendErrors.password = "This password is compromised. Please choose another one.";
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                
                if (!self.cpassword) {
                    self.frontendErrors.cpassword = 'Confirm Required';
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.password != self.cpassword) {
                    self.frontendErrors.cpassword = 'Password Does Not Match';
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            attemptResetPassword: function() {
                self.checkForm();
                if (self.checkForm()) {
                    self.buttonNames.submitButton = "Submiting...";
                    self.disableButtons.submitButton = true;
                    var fields = {
                        token: self.customerToken,
                        password: self.password,
                    };
                     HTTP.post("/customer/forgot/password", fields)
                        .then(function (response) {
                            self.buttonNames.submitButton = "Submit";
                            self.disableButtons.submitButton = false;
                            if (response.data.status == "success") {
                                self.backBtn();
                            }
                            if (response.data.code != 200) {
                                $('#errorMsg').html(response.data.message);
                            }
                        })
                        .catch(function (err) {
                            self.buttonNames.submitButton = "Submit";
                            self.disableButtons.submitButton = false;
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                $('#errorMsg').html(err.response.data.message);
                            }
                        });
                }
            },
        },
    }
</script>  
<style>

.strength-meter {
    width: 100%;
    height: 10px;
    background: #e0e0e0;
    border-radius: 5px;
    margin-top: 10px;
    position: relative;
    overflow: hidden;
}

.strength-bar {
    height: 100%;
    transition: width 0.3s ease, background-color 0.3s ease;
}

.strength-label {
    margin-top: 5px;
    font-weight: bold;
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Login/CustomerResetPassword.vue